<template>
	<div class="hide-outline">
		<TopPanel
			:units="[$t('file_view.singular'), $t('file_view.plural'), $t('file_view.new')]"
			:pagination="pagination"
			:showCustomer="true"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			:showBuildings="true"  
			hideAdd
			@search="search"
			@orderBy="orderBy"
		/>
			<div class="field" style="margin: .5rem 0;">
			<label class="label" style="margin-bottom:.25rem;">
				{{ $t('file_list.building_filter') }}
			</label>
			
		</div>
		
		
		<div class="main-view columns flex-column">
			<FileList
				:files="filteredFiles"
				:attach-building.sync="attachBuilding"
				:toggle-disabled="toggleDisabled"
				@delete="askToDeleteFile"
				@search="getFiles(1)"
				@save="save"
				@download="download"
			/>
		</div>
	 
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
		
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import TopPanel from '@/components/TopPanel';
import FileList from './components/FileList';
import DeleteModal from '@/components/DeleteModal';
import buildingService from '@/services/building';
import UiSwitch from '@/components/ui/ui-switch';

export default {
	components: {
		TopPanel,
		FileList,
		DeleteModal,
		UiSwitch
	},
	data: () => ({
		showDelete: false,
		selectedFile: {},
		buildings: [],            
  		selectedBuildingId: null,
		attachBuilding: false,
	}),

	computed: {
		...mapGetters('user', ['getActiveCustomer']),
		...mapGetters('fileStore', ['files', 'pagination']),
		...mapState('fileStore', ['searchParams']),
		...mapGetters('buildingStore', ['selectedBuilding']),


		activeCustomerId() {
			return this.getActiveCustomer?.id || null;
		},

		effectiveBuildingId() {
			const idFromStore = this.selectedBuilding?.id || null;
			const id = idFromStore ?? this.selectedBuildingId ?? null;

			if (!id || id === '__userBuildingId__') return null;
			return String(id); 
		},
		toggleDisabled() {
			return !this.effectiveBuildingId;
		},
		
		deleteMessage() {
			return this.$t('file_view.confirm_delete', { name: this.selectedFile.name });
		},

		orderBys() {
			return [
				{ name: this.$t('common.order_name'), value: 'Name' },
				{ name: this.$t('common.order_created'), value: 'Created' }
			];
		},
		filteredFiles() {
			const cid = this.getActiveCustomer?.id;
			let list = Array.isArray(this.files) ? this.files : [];

			if (cid != null && list.some(f => f.customerId != null || f.CustomerId != null)) {
				list = list.filter(f => String(f.customerId ?? f.CustomerId) === String(cid));
			}

			const chosenBuildingId = this.effectiveBuildingId;
			if (chosenBuildingId) {
				list = list.filter(f => String(f.buildingId ?? f.BuildingId ?? '') === String(chosenBuildingId));
			}

			return list;
		},
	},

	watch: {
		'getActiveCustomer.id'() {
			this.getFiles(1);
			this.fetchBuildings();       
			this.selectedBuildingId = null; 
		},
		activeCustomerId: {
			immediate: true,
			handler() {
			this.getFiles(1);
			this.fetchBuildings();
			this.selectedBuildingId = null;
			}
		},
		effectiveBuildingId(newId) {
			if (!newId) this.attachBuilding = false;
		}
	},

	created() {
		this.fetchBuildings();
	},

	methods: {
		...mapActions('user', ['setActiveCustomer']),
		...mapActions('fileStore', [
			'getFiles',
			'saveFile',
			'deleteFile',
			'downloadFile'
		]),


		search(searchValue) {
			this.searchParams.name = searchValue;
			this.getFiles(1);
		},

		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getFiles(1);
		},

		askToDeleteFile(file) {
			this.selectedFile = file;
			this.showDelete = true;
		},

		cancelDelete() {
			this.showDelete = false;
			this.selectedFile = {};
		},

		deleteSelected() {
			this.deleteFile(this.selectedFile).then(() => {
				this.cancelDelete();
			});
		},

		save(file, meta = {}) {
			const chosenBuildingId =
				meta.buildingId ??
				(this.attachBuilding ? this.effectiveBuildingId : null);

			console.log('[save] attachBuilding=', this.attachBuilding,
						'effectiveBuildingId=', this.effectiveBuildingId,
						'chosenBuildingId=', chosenBuildingId);

			const params = {
				customerId: this.getActiveCustomer?.id,
				file,
				documentType: 1,
				...(chosenBuildingId ? { buildingId: chosenBuildingId } : {})
			};

			this.saveFile(params).then(() => this.getFiles(1));
		},

		download(file) {
			this.downloadFile(file.id).then(data => {
				const url = window.URL.createObjectURL(new Blob([data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', file.name);
				document.body.appendChild(link);
				link.click();
				this.$nextTick(() => {
					document.body.removeChild(link);
				});
			});
		},

		async fetchBuildings() {
  const cid = this.getActiveCustomer?.id;
  try {
    if (!cid) { this.buildings = []; return; }

    const { data } = await buildingService.getBuildingsOnCustomer(cid);

    let payload = data;
    if (typeof payload === 'string') {
      try { payload = JSON.parse(payload); } catch (_) { payload = []; }
    }

    const list =
      Array.isArray(payload) ? payload :
      Array.isArray(payload?.data) ? payload.data :
      Array.isArray(payload?.value) ? payload.value : [];

    this.buildings = list.map(b => ({
      id: b.id ?? b.buildingId,
      name: b.name ?? b.buildingName ?? '(unnamed)'
    })).filter(x => x.id);

  } catch (e) {
    console.error('Failed to load buildings', e);
    this.buildings = [];
  }
},

		
}
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
@import "@/assets/colors.scss";

.panel.info-panel {
  position: absolute;
  pointer-events: none;
  margin-left: -8px;
  top: $navbar-height + 0.75rem;
  background-color: transparent;
  width: calc(100% - 300px);
  color: $white;
  border-radius: 0;
  z-index: 1;
  &.mobile {
    z-index: 4;
    position: fixed;
  }
}
</style>
